import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/radar/worldcup')({
  beforeLoad: ({ params }) => {
    throw redirect({ href: `/${params.locale}/matches`, replace: true })
  },
})
